import React from 'react';

const ServicesSection = () => {
  const services = [
    { color: 'blue', image: '/Icons/LGA-HomePage-SupportedIndependentLiving-Icon.svg', alt: 'Service 1', title: 'Supported Independent Living', link: "/properties"},
    { color: 'yellow', image: '/Icons/LGA-Property-Tenants-Icon.svg', alt: 'Service 2', title: 'Supported Accommodation', link: "/sda-homes"},
    { color: 'green', image: '/Icons/LGA-HomePage-InHomeSupport-Icon.svg', alt: 'Service 3', title: 'In-Home Support', link: "/services/inhome-support"},
    { color: 'yellow', image: '/Icons/LGA-HomePage-CommunityParticipation-REVISED.svg', alt: 'Service 4', title: 'Community Participation', link: "/services/community"},
    { color: 'blue', image: '/Icons/LGA-HomePage-TransitionandRespiteCare-Icon.svg', alt: 'Service 5', title: 'Transition & Respite Care', link: "/services/respite"},
  ];

  return (
    <div className="flex flex-col items-center p-8 max-w-6xl mx-auto">
      <h1 className="text-6xl font-bold mt-12 mb-16 text-primary font-arial-rounded">Our Services</h1>
      
      <div className="flex flex-wrap justify-center gap-12">
        {services.map((service, index) => (
          <div
            key={index}
            className="relative flex flex-col items-center gap-6"
          >
            <a 
              href={service.link} 
              className="group transition-transform hover:scale-105 flex flex-col items-center"
            >
              <div className="relative w-40 h-40 flex items-center justify-center mb-4">
                <div 
                  className={`absolute inset-0 rounded-full 
                    transform -translate-x-1 -translate-y-1`}
                />
                <img 
                  src={service.image}
                  alt={service.alt}
                  className="relative w-40 h-40 object-contain z-10"
                />
              </div>
              <p className="text-primary font-bold text-center w-32 text-sm group-hover:underline">
                {service.title}
              </p>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;